import { IAddress } from './Address.types';

export enum CompanyRole {
  BOTH = 'BOTH',
  BUYER = 'BUYER',
  SELLER = 'SELLER',
}

// New Company

export interface ICompany {
  address: IAddress;
  coc_number: string;
  company_settings: ICompanySettings;
  created_at: string;
  customer_number: string;
  email: string;
  id: number;
  is_active: boolean;
  logo_url: string;
  name: string;
  phone_number: string;
  role: CompanyRole;
  vat_number: string;
  website: string;
  has_system_integration: boolean;
}

export interface ICompanyBuyerDTO {
  name: string;
  reference_number: string;
  navigationID: string;
}

// Company management
export interface ICompanyData {
  name: string;
  vat_number: string;
  coc_number: string;
  website: string;
  email: string;
  phone_number: string;
  address?: IAddress;
}

export interface IFixedExchangeRates {
  [key: string]: number;
}

export interface IAdditionalCartDetails {
  [key: string]: string;
}

export interface ICompanySettings {
  vat_percentage: number;
  pricing_currency: string;
  display_currency?: string;
  quotation_prefix: string;
  order_prefix: string;
  is_gross_visible: boolean;
  allowed_delivery_countries: string[] | null;
  fixed_exchange_rates?: IFixedExchangeRates;
  additional_cart_details?: IAdditionalCartDetails | null;
}

export interface IRegisterNewCompanyParams {
  token: string;
  userId: number;
  name: string;
  email: string;
  address: IAddress;
}
